import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

import { TypographyH3 } from '@/Components/shadcn';
import { cn } from '@/lib/utils';
import UIStrings from '@/Utils/UIStrings';

import CandidateTestMonitoringFeature from './CandidateTestMonitoringFeature';

export interface CTMonitoringHeaderProps {
    isWebcamEnabled: boolean;
    isScreenSnapshotsEnabled: boolean;
    isFullScreenEnabled: boolean;
    isOpened: boolean;
    togglePanel: () => void;
}

function CTMonitoringHeader({
    isWebcamEnabled,
    isScreenSnapshotsEnabled,
    isFullScreenEnabled,
    isOpened,
    togglePanel,
}: CTMonitoringHeaderProps): React.JSX.Element {
    const handleHeaderKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            togglePanel();
        }
    };

    return (
        <div
            role="button"
            tabIndex={0}
            aria-expanded={isOpened}
            className={cn(
                'border-border bg-card flex cursor-pointer flex-row items-center justify-between border-1 py-2 pr-2 pl-4',
                isOpened ? 'rounded-t-lg rounded-b-none border-b-0' : 'rounded-lg',
            )}
            onClick={togglePanel}
            onKeyDown={handleHeaderKeyDown}
        >
            <TypographyH3>{UIStrings.ApplicantTestMonitoring}</TypographyH3>
            <CandidateTestMonitoringFeature label={UIStrings.ScreenSnapshots} isEnabled={isScreenSnapshotsEnabled} />
            <CandidateTestMonitoringFeature label={UIStrings.WebcamSnapshots} isEnabled={isWebcamEnabled} />
            <CandidateTestMonitoringFeature label={UIStrings.FullscreenMode} isEnabled={isFullScreenEnabled} />
            <span className="inline-flex size-10 shrink-0 items-center justify-center" aria-hidden>
                {isOpened ? (
                    <ChevronUp className="size-6" aria-hidden />
                ) : (
                    <ChevronDown className="size-6" aria-hidden />
                )}
            </span>
        </div>
    );
}

export default CTMonitoringHeader;
